import axios from "axios";
import Config from "../Services/Config";
import { encryptAuthPhrase } from "../Pages/Utilities/Utils";
const tpauthphrase = encryptAuthPhrase();
const today = new Date();
const dot = `${today.getFullYear()}${String(today.getMonth() + 1).padStart(
  2,
  "0"
)}${String(today.getDate()).padStart(2, "0")}`;
const userLogin = (data, methodName) => {
  const headers = {
    "Content-Type": "application/json",
    branchid: "1",
    methodname: methodName,
    source: "TP",
    dot: dot,
    userid: "1",
    tdauthcode: "b9a4f7d6-a039-4fbb-9265-8fb3ea0019bb",
    tpauthphrase: tpauthphrase,
  };

  return axios.post(`${Config.API_URL}/go/erp`, data, {
    headers,
  });
};
const getOptionslist = (data, methodName) => {
  const headers = {
    "Content-Type": "application/json",
    branchid: "1",
    methodname: methodName,
    source: "TP",
    dot: dot,
    userid: "1",
    tdauthcode: "b9a4f7d6-a039-4fbb-9265-8fb3ea0019bb",
    tpauthphrase: tpauthphrase,
  };
  return axios.post(`${Config.API_URL}/go/erp`, data, {
    headers,
  });
};
const getTableList = (data, methodName) => {
  console.log(" data", data);

  const headers = {
    "Content-Type": "application/json",
    branchid: "1",
    methodname: methodName,
    source: "TP",
    dot: dot,
    userid: "1",
    tdauthcode: "b9a4f7d6-a039-4fbb-9265-8fb3ea0019bb",
    tpauthphrase: tpauthphrase,
  };
  return axios.post(`${Config.API_URL}/go/erp`, data, {
    headers,
  });
};
const saveTaxGroups = (payload, methodName) => {
  const headers = {
    "Content-Type": "application/json",
    branchid: "1",
    methodname: methodName,
    source: "TP",
    dot: dot,
    userid: "1",
    tdauthcode: "b9a4f7d6-a039-4fbb-9265-8fb3ea0019bb",
    tpauthphrase: tpauthphrase,
  };
  return axios.post(`${Config.API_URL}/go/erp`, payload, {
    headers,
  });
};

const logout = (payload,methodName) => {
  const headers = {
    "Content-Type": "application/json",
    branchid: "1",
    methodname: methodName,
    source: "TP",
    dot: dot,
    userid: "1",
    tdauthcode: "b9a4f7d6-a039-4fbb-9265-8fb3ea0019bb",
    tpauthphrase: tpauthphrase,
    // sessionid: sessionid,
  };
  return axios.post(`${Config.API_URL}/go/erp`, payload, {
    headers,
  });
};
const authService = {
  userLogin,
  getOptionslist,
  getTableList,
  saveTaxGroups,
  logout,
};
export default authService;
